import { render, staticRenderFns } from "./UpgraderFilterSort.vue?vue&type=template&id=48cc29be&scoped=true"
import script from "./UpgraderFilterSort.vue?vue&type=script&lang=js"
export * from "./UpgraderFilterSort.vue?vue&type=script&lang=js"
import style0 from "./UpgraderFilterSort.vue?vue&type=style&index=0&id=48cc29be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc29be",
  null
  
)

export default component.exports